export default "__VITE_ASSET__Fu28whvW__";